export default __webpack_public_path__ + "5a7ba3cbab026b3da0b531576ef2731a.png";